interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeader({ eyebrow, title, desc, align = 'left' }: Props) {
  const centered = align === 'center';
  return (
    <div className={`mb-8 flex flex-col ${centered ? 'items-center text-center' : 'items-start'}`}>
      {eyebrow && (
        <span className="mb-3 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl text-foreground-950 md:text-4xl">{title}</h2>
      {desc && (
        <p className={`mt-3 max-w-2xl text-sm text-foreground-600 md:text-base ${centered ? 'mx-auto' : ''}`}>
          {desc}
        </p>
      )}
    </div>
  );
}